<template>
  <div class="login-wrap">
    <p class="text">
      404
      <br />
      <span>您访问的页面不存在</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "page404"
};
</script>

<style lang="less"  scoped>
.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #2a80e0;
}

.text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 60px;
  font-weight: bolder;
  color: #fff;
  text-align: center;

  span {
    font-size: 20px;
  }
}
</style>
